import { render, staticRenderFns } from "./companyHistory.vue?vue&type=template&id=7d34ff0c&"
import script from "./companyHistory.vue?vue&type=script&lang=js&"
export * from "./companyHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports